import React from "react";
import classes from "../Store.module.scss";
import RoundButton from "../../../../components/Buttons/RoundButton";
import { useTranslation } from "react-i18next";
import * as api from "../../../../constants/api";
import { useNavigate } from "react-router";

interface ReviewCardCardProps {
  qntOfJourneys: number;
  productInfo: { price: number; id_product?: number }[];
  productChoosed: number;
  isInvoiceDataFilled: boolean;
  termsCheckBox: boolean;
  getPixFetch: (params: any) => void;

  userInfo: {
    name: string;
    professional_ssn: string;
    street: string;
    number: string;
    complement?: string;
    cep: string;
    neighborhood: string;
    city: string;
    state: string;
    country: string;
  };

  stage: number;
  cSession: any;
  adminSub: string;

  setStage: (value: number) => void;
  setTermsCheckBox: React.Dispatch<React.SetStateAction<boolean>>;
}

const ReviewCardCard: React.FC<ReviewCardCardProps> = ({
  qntOfJourneys,
  productInfo,
  stage,
  setStage,
  productChoosed,
  isInvoiceDataFilled,
  userInfo,
  termsCheckBox,
  getPixFetch,
  cSession,
  adminSub,
  setTermsCheckBox,
}) => {
  const { t } = useTranslation();
  const history = useNavigate();

  return (
    <div className={classes.ReviewCardCard}>
      <h2>{t("global.purchase_summary")}</h2>
      <div>
        <div className={classes.InfosDetailsPrice}>
          <div>{t("global.selected_journeys")}:</div>
          <div>{qntOfJourneys}</div>
        </div>
        <div className={classes.InfosDetailsPrice}>
          <div>{t("global.unit_price")}</div>
          <div>
            R${" "}
            {qntOfJourneys === 0
              ? "0,00"
              : (productInfo[productChoosed]?.price / qntOfJourneys)
                  ?.toFixed(2)
                  .replace(".", ",")}
          </div>
        </div>
      </div>
      <div className={classes.barDivider} />
      <div className={classes.InfosDetailsPriceTotal}>
        <div className={classes.InfosDetailsPriceTotal1}>
          <h3>{t("global.total")}:</h3>
          <h3>
            R${" "}
            {qntOfJourneys === 0
              ? "0,00"
              : qntOfJourneys === 5
                ? productInfo[0]?.price?.toFixed(2).replace(".", ",")
                : productInfo[1]?.price?.toFixed(2).replace(".", ",")}
          </h3>
        </div>
      </div>
      {stage === 2 && (
        <div className={classes.CalculateButtonContainer}>
          <RoundButton
            huge
            disabled={!isInvoiceDataFilled}
            onClick={() => setStage(3)}
            text={t("global.continue")}
            title={t("global.continue")}
          />
        </div>
      )}
      {stage === 3 && (
        <div className={classes.CalculateButtonContainer}>
          <RoundButton
            onClick={() => {
              const dataToSent = {
                professional_sub: adminSub,
                product_id: productInfo[productChoosed]?.id_product,
                first_name: userInfo.name,
                name: userInfo.name,
                last_name: userInfo.name.split(" ")[1],
                professional_ssn: userInfo.professional_ssn.replace(/\D/g, ""),
                email: cSession?.admin?.email ?? "",
                address_street: userInfo.street,
                address_number: userInfo.number,
                address_additional_details: userInfo.complement,
                address_zipcode: userInfo.cep.replace(/\D/g, ""),
                address_neighborhood: userInfo.neighborhood,
                address_city: userInfo.city,
                address_state: userInfo.state,
                address_country: userInfo.country,
              };
              getPixFetch({
                method: "POST",
                url: api.API_PRO_GET_PIX,
                data: dataToSent,
                onSuccess: (data: any) => {},
                onError: (error: any) => {
                  console.error("Erro ao criar pix:", error);
                  setStage(6);
                },
              });
              setStage(4);
            }}
            text={t("purchase.pix_with_payment")}
            title={t("purchase.pix_with_payment")}
            disabled={!termsCheckBox}
          />
        </div>
      )}
      <div className={classes.ButtonsArea}>
        <button
          onClick={() => {
            stage === 1 ? history("/") : setStage(stage - 1);
            setTermsCheckBox(false);
          }}
        >
          VOLTAR
        </button>
      </div>
    </div>
  );
};

export default ReviewCardCard;
